// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "gift_card".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "gift_card" table (1:1 with a DB row, on the wire). */
export const giftCardAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    code: z.string(),
    initialAmountCents: z.number(),
    balanceCents: z.number(),
    currency: z.string(),
    expiresAt: z.string().datetime().nullable(),
    leadId: z.string().nullable(),
    saleItemId: z.string().nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=giftCard.js.map